import { useState, useEffect } from 'react';

export const useValidPhone = (initialValue: string | null) => {
  const [phone, setPhone] = useState(initialValue);
  const [phoneIsValid, setPhoneIsValid] = useState('');

  useEffect(() => {
    if (phone !== null) {
      if (phone.length === 0) {
        setPhoneIsValid('Please check your phone number');
        return;
      }
    } else {
      setPhoneIsValid('');
      return;
    }

    if (phone.length !== 10) {
      setPhoneIsValid('Please check your phone number');
      return;
    }
    setPhoneIsValid('');
  }, [phone]);

  return { phone, setPhone, phoneIsValid };
};
